import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'jb-accordion-container',
  templateUrl: './accordion-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionContainerComponent {
  accordionBlock: any;
  expandedItem: number;

  onOpen(i: number) {
    this.expandedItem = i;
  }

  onClose(i: number) {
    // only set expandedItem to null if closing the open panel
    // do not reset expandedItem if closing the panel as a result of opening another panel
    if (this.expandedItem === i) {
      this.expandedItem = null;
    }
  }
}

export const accordionContainerResolver = (registry, data) => ({
  accordionBlock: data.accordion ? data.accordion : data.accordionBlock,
});
